import { createContext } from 'react';

export interface SearchBarType {
  condensed: boolean;
}

export const SearchBarContext = createContext<SearchBarType | null>(null);
